import { auctionApi } from '~/api/auction'
import { SignInGoogleResponse } from '~/api/auction/types'

export const userSignIn = async (token: string) => {
  try {
    const response = await auctionApi.users.signIn.google.query({
      code: token, // Le token reçu de Google
    })
    if (response) {
      // Sauvegarder le token et les infos utilisateur dans le localStorage
      localStorage.setItem('token', response.token)
      localStorage.setItem('user', JSON.stringify(response.user))
      return response
    }
    throw new Error('Authentication failed')
  } catch (error) {
    console.error('Error during user sign-in:', error)
    throw error
  }
}

export const getUser = (): SignInGoogleResponse['user'] | null => {
  const user = localStorage.getItem('user')
  console.log('getUser', user)
  if (user) {
    return JSON.parse(user) as SignInGoogleResponse['user']
  }
  return null
}

export const userSignOut = () => {
  // Supprimer le token et les infos utilisateur du localStorage
  localStorage.removeItem('token')
  localStorage.removeItem('user')
  // Rediriger vers la page de connexion ou d'accueil
  window.location.href = '/signin'
}
